export default __webpack_public_path__ + "37c50fbe6670cc96c01d96997bccbb0c.jpg";